module.exports = __webpack_public_path__ + "static/crystal-82605651cf38bfe04e02cb99507b52f0.png";